import { FC } from "react";
import { Typography } from "@mui/material";
type Props = {
  total?: number;
  perPage?: number;
  page?: number;
};
export const CountTable: FC<Props> = ({ total = 0, perPage = 0, page = 0 }) => {
  const formatTotal = (total: number = 0) => {
    return total.toLocaleString("en-US");
  };
  return (
    <Typography variant="body14Semi">
      全 {formatTotal(total) ?? 0} 件中 {Math.min((page ?? 1) * (perPage ?? 20), total ?? 0)} 件を表示
    </Typography>
  );
};
